"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Sync64Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "64px", height: "64px", viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "sync-64", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M11,31.5 C11,38.6797017 16.8202983,44.5 24,44.5 L48.577,44.5 L44.1937288,40.1163891 L46.3150492,37.9950687 L54.3172047,45.9972242 L46.3150492,53.9993797 L44.1937288,51.8780594 L48.571,47.5 L24,47.5 C15.163444,47.5 8,40.336556 8,31.5 L11,31.5 Z M18.0021555,10 L20.1234758,12.1213203 L15.744,16.5 L40,16.5 C48.836556,16.5 56,23.663444 56,32.5 L53,32.5 C53,25.3202983 47.1797017,19.5 40,19.5 L15.74,19.5 L20.1234758,23.8829906 L18.0021555,26.004311 L10,18.0021555 L18.0021555,10 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function Sync64(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Sync64Svg, Object.assign({}, svgProps)));
}
exports.default = Sync64;
//# sourceMappingURL=Sync64.js.map